<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createDocflow') }}</h1>
      <div class="form-container">
        <DocflowAppealForm @save="save"></DocflowAppealForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import DocflowAppealForm from '@/components/DocflowAppealForm'

  export default {
    components: {
      DashboardLayout,
      DocflowAppealForm
    },
    methods: {
      save(documentForm) {
        this.$store.dispatch('Docflow/create', {
          ...documentForm,
          category: 'appeals'
        }).then(document => {
          this.$router.push({
            name: 'docflowAppealDetail',
            params: {documentId: document.id}
          })
        })
      }
    },
    mounted() {
      this.$store.dispatch('Docflow/getRelations', {category: 'appeals', documentId: null})
    },
    computed: {
      breadcrumbs() {
        return [
          {name: 'docflow'},
          {name: 'docflowAppeals', path: 'docflowAppeals'},
          {name: 'createDocflow'}
        ]
      }
    }
  }
</script>
